import {Component, computed, forwardRef, input, signal} from '@angular/core';
import {ChoiceBaseComponent} from '@shared/form/choice/choice-base.component';
import {AbstractControl, NG_VALUE_ACCESSOR} from '@angular/forms';
import {LucideAngularModule} from 'lucide-angular';
import {AbstractFieldComponent, ValidationError} from '@shared/field/abstract-field.component';
import {FieldBaseComponent} from '@shared/form/field-base.component';
import {NgIf} from '@angular/common';
import {TranslocoDirective} from '@jsverse/transloco';
import {toSignal} from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-field-container',
  imports: [
    LucideAngularModule,
    TranslocoDirective
  ],
  templateUrl: './field-container.component.html',
  styleUrl: './field-container.component.scss'
})
export class FieldContainerComponent<valueT> {

  public readonly field = input.required<FieldBaseComponent<valueT>>();

  public readonly hasErrors = computed(() => this.field().hasErrors());
  public readonly errors = computed(() => this.field().errors());

  // private readonly ngControl = computed(() => this.field()?.ngControl);
  //
  // public readonly controlErrors = toSignal(
  //   this.form.controls.validFrom.valueChanges,
  //   { initialValue: this.form.controls.validFrom.value }
  // );

  // public readonly fieldErrors = computed(() => Object.entries(this.field()?.ngControl?.errors ?? {}).map(([key, error]) => ({key: key, error: error} as ValidationError)));

  private readonly toggleHint = signal(false);

  public readonly showHintToggle = computed(() => !!this.field()?.hint() && this.field()?.hintMode() === 'toggle');

  public readonly showHint = computed(() => {
    const hint = this.field()?.hint();
    if (!hint) {
      return false;
    }
    const hintMode = this.field()?.hintMode();
    return hintMode === 'always' || this.toggleHint();
  });

  public readonly hintToggleLabel = computed(() => this.toggleHint() ? 'Masquer' : 'En savoir plus');

  public toggleShowHint(): void {
    this.toggleHint.update(show => !show);
  }

}
